$(document).ready(function() {
	//Установка маски для поля ввода номера телефона
	let leadFormPhone = document.getElementById('lead-form-phone');
  let maskOptions = {
    mask: '+{7} (000) 000 00 00'
  };
  let mask = IMask(leadFormPhone, maskOptions);
  //Вадидация формы
	let regex = /^([a-zA-Zа-яА-ЯёЁ -]+|\d+)$/i;
	$(document).on('keyup', '.js-lead-form-name', function() {
		let parentWrapName = $(this).parent('.js-lead-form-wrap');
		if (!(regex.test($(this).val().toLowerCase())) || ($(this).val() === "")) {
			$(parentWrapName).addClass('error');
			$('.js-lead-form-button').prop("disabled", true);
		} else {
			$(parentWrapName).removeClass('error');
			if($('#cbx-lead').is(':checked') && !($('.js-lead-form-phone').val().length < 18)) {
				$('.js-lead-form-button').prop("disabled", false);
			}
		}
	});
	$(document).on('keyup', '.js-lead-form-phone', function() {
		let parentWrapPhone = $(this).parent('.js-lead-form-wrap');
		if ($(this).val().length < 18) {
			$(parentWrapPhone).addClass('error');
			$('.js-lead-form-button').prop("disabled", true);
		} else {
			$(parentWrapPhone).removeClass('error');
			if($('#cbx-lead').is(':checked') && !($('.js-lead-form-name').val() === "")) {
				$('.js-lead-form-button').prop("disabled", false);
			}
		}
	});
	$(document).on('click', '#cbx-lead', function() {
		if($(this).is(':checked')) {
			if ((regex.test($('.js-lead-form-name').val().toLowerCase())) 
						&& !($('.js-lead-form-name').val() === "")
						&& !($('.js-lead-form-phone').val().length < 18)) {
				$('.js-lead-form-button').prop("disabled", false);
			}
			if (!(regex.test($('.js-lead-form-name').val().toLowerCase())) || ($('.js-lead-form-name').val() === "")) {
				$('.js-lead-form-name').parent('.js-lead-form-wrap').addClass('error');
			} else {
				$('.js-lead-form-name').parent('.js-lead-form-wrap').removeClass('error');
			}
			if ($('.js-lead-form-phone').val().length < 18) {
				$('.js-lead-form-phone').parent('.js-lead-form-wrap').addClass('error');
			} else {
				$('.js-lead-form-phone').parent('.js-lead-form-wrap').removeClass('error');
			}
		} else {
			$('.js-lead-form-button').prop("disabled", true);
		}
	});
	//Нажатие на кнопку "Отправить"
	$(document).on('click', '.js-lead-form-button', function(e) {
		e.preventDefault();
		$('.js-lead-form-success').show();
	})
});


// WEBPACK FOOTER //
// ./src/js/pages/promo/lead-validation.js